import { defineMessages } from 'react-intl'

const scope = `procurify.modules.spending-cards.features.unlock-card-admin`

export default defineMessages({
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage: 'Card unlocked',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Could not unlock card',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Do you want to unlock this card?',
  },
  modalContent: {
    id: `${scope}.modalContent`,
    defaultMessage: 'Unlock to restore purchasing with this card.',
  },
  modalConfirmButton: {
    id: `${scope}.modalConfirmButton`,
    defaultMessage: 'Unlock card',
  },
})
